import firebase from 'firebase/app'
import 'firebase/auth'
import gen from '../gen'
import emailPassword_otherFunctions from './emailPassword_otherFunctions'

const state = {
  emailPassword_signup_displayName: '',
  emailPassword_signup_email: '',
  emailPassword_signup_password: ''
}

const getters = {

}

const mutations = {
  //
  emailPassword_signup(state2, payload){
    console.log(payload)
    //
    let displayName = payload.displayName //check if empty //
    let email = payload.email
    let password = payload.password
    //
    let checkVarsIfEmpty_arr = []
    checkVarsIfEmpty_arr.push({
      fieldValue: displayName,
      fieldName: 'Name'
    })
    //
    gen
      .actions
      .isEmptyField(state, {
        checkVarsIfEmpty_arr
      })
      .then((isEmpty)=>{
        //console.log("[isEmptyField] => ", result)
        if(!isEmpty){
          //
          gen.state.btnLoader = true
          //
          firebase
            .auth()
            .createUserWithEmailAndPassword(email, password)
            .then(()=>{
              //
              var user = firebase.auth().currentUser;
              //console.log("user => ", user)
              //
              user.updateProfile({
                displayName
              }).then(function() {
                //console.log("// Update successful. //Display Name")
                //
                state.emailPassword_signup_displayName = ''
                state.emailPassword_signup_email = ''
                state.emailPassword_signup_password = ''
                //
                gen.mutations.snackbar_alert(state, {
                  msg:  'Account Created Successfully !'
                })
                //
                setTimeout(()=>{
                  emailPassword_otherFunctions.mutations.resendEmailVerficationLink(state)
                }, 4000)
                //
                window.thisOfHeader.$forceUpdate()
                //
                //route
                gen.mutations.goTo(state, '/')
                //
                gen.state.btnLoader = false
                //
              }).catch(function(error) {
                // An error happened.
                //console.log(error)
                //
                gen.mutations.snackbar_alert(state, {
                  msg:  error.message
                })
                //
                gen.state.btnLoader = false
              });
              //
            }).catch(function(error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            // ...
            gen.mutations.snackbar_alert(state, {
              msg:  error.message
            })
            //
            gen.state.btnLoader = false
          });
          //
        }
    })
  }
}

const actions = {

}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/emailPassword_signup.js